import Vue from 'vue'
import Router from 'vue-router'
// import Landing from './views/Landing'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
    {
        path: '*',
        name: 'Home Page',
        component: () =>
            import ('./views/Landing')
    },    
    {
        path: '/about',
        name: 'About Page',
        component: () =>
        import ('./views/About')
    },
    // {
    //     path: '/team',
    //     name: 'Team Page',
    //     component: () =>
    //     import ('./views/Team')
    // },
    {
        path: '/team/:name',
        name: 'Team Member Page',
        component: () =>
        import ('./views/TeamMember')
    },
    {
        path: '/contact',
        name: 'Contact Page',
        component: () =>
        import ('./views/Contact')
    },
    {
        path: '/work',
        name: 'Work Page',
        component: () =>
        import ('./views/Work'),
        children: [
            {
                path: '/work',
                name: 'Work',
                component: () =>
                import ('./views/projects/WorkHome')
            },
            {
                path: 'universe',
                name: 'Universe',
                component: () =>
                import ('./views/projects/Universe')
            },
            {
                path: 'prepack-planner',
                name: 'Prepack Planner',
                component: () =>
                import ('./views/projects/Prepack')
            },
            {
                path: 'clarity',
                name: 'Clarity',
                component: () =>
                import ('./views/projects/Clarity')
            },
            {
                path: 'surface',
                name: 'Surface',
                component: () =>
                import ('./views/projects/Surface')
            },
            {
                path: 'higher',
                name: 'Higher',
                component: () =>
                import ('./views/projects/Higher')
            },
            {
                path: 'winning',
                name: 'Winning',
                component: () =>
                import ('./views/projects/Winning')
            },
          ]
    },
    {
        path: '/creative',
        name: 'Creative Page',
        component: () =>
        import ('./views/Creative')
    },
    {
        path: '/digital',
        name: 'Digital Page',
        component: () =>
        import ('./views/Digital')
    },
    {
        path: '/translations',
        name: 'Translations Page',
        component: () =>
        import ('./views/Translations')
    },
    {
        path: '/careers',
        name: 'Careers Page',
        component: () =>
        import ('./views/Careers')
    },
],
   scrollBehavior () {
    return { x: 0, y: 0};
  }
})